(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
(function(){
  var S = window.__MP = window.__MP || {};

  function cfg(sid){
    if(S[sid]) return S[sid];
    var el = document.querySelector('[data-mp-cfg="'+sid+'"]');
    if(!el) return null;
    var c;
    try { c = JSON.parse(el.textContent); } catch(e){ return null; }
    c.tier = 1;
    c.slots = {};
    S[sid] = c;
    var root = document.querySelector('[data-mp="'+sid+'"]');
    var onTier = root && root.querySelector('.tier.on');
    c.tier = onTier ? parseInt(onTier.getAttribute('data-mp-tier'), 10) : 1;
    return c;
  }

  function root(sid){ return document.querySelector('[data-mp="'+sid+'"]'); }
  /* Learns decimals, separators, prefix and suffix from a Liquid-rendered sample
     (100000 cents = 1000.00) so JS totals render exactly like the Liquid `money` filter. */
  function shape(sample){
    var m = /[\d][\d.,'  ]*\d|\d/.exec(sample || '');
    if(!m) return {pre:'', suf:' ', dec:2, ds:'.', ts:','};
    var num = m[0];
    var tail = /([.,])(\d{1,4})$/.exec(num);
    var ds = tail ? tail[1] : '.';
    var dec = tail ? tail[2].length : 0;
    var whole = tail ? num.slice(0, -(dec + 1)) : num;
    var tsm = /[^\d]/.exec(whole);
    return {
      pre: sample.slice(0, m.index),
      suf: sample.slice(m.index + num.length),
      dec: dec, ds: ds, ts: tsm ? tsm[0] : ''
    };
  }
  function money(cents, sample){
    var s = shape(sample);
    var v = (Math.abs(cents) / 100).toFixed(s.dec).split('.');
    var whole = s.ts ? v[0].replace(/(\d)(?=(\d\d\d)+$)/g, '$1' + s.ts) : v[0];
    return s.pre + whole + (s.dec ? s.ds + v[1] : '') + s.suf;
  }

  /* ---------- gallery ---------- */
  window.mpSet = function(sid, i){
    var c = cfg(sid), r = root(sid); if(!c || !r) return;
    var main = r.querySelector('#mpMain-'+sid), wrap = r.querySelector('#mpThumbs-'+sid);
    if(!main || !wrap) return;
    var th = wrap.children;
    if(i < 0) i = th.length - 1;
    if(i >= th.length) i = 0;
    main.src = c.images[i] || th[i].src;
    for(var k=0;k<th.length;k++) th[k].classList.toggle('on', k===i);
    wrap.setAttribute('data-idx', i);
    if(th[i].scrollIntoView) th[i].scrollIntoView({block:'nearest', inline:'center', behavior:'smooth'});
  };
  window.mpStep = function(sid, d){
    var wrap = document.querySelector('#mpThumbs-'+sid); if(!wrap) return;
    mpSet(sid, parseInt(wrap.getAttribute('data-idx')||'0',10) + d);
  };

  /* ---------- tiers + variant slots ---------- */
  function renderSlots(sid){
    var c = cfg(sid), r = root(sid); if(!c || !r || !c.hasVariants) return;
    var wrap = r.querySelector('[data-mp-vp]'); if(!wrap) return;
    var box = wrap.querySelector('[data-mp-slots]');
    var tier = r.querySelector('[data-mp-tier="'+c.tier+'"]'); if(!tier) return;
    var n = c.tier;
    var qty = parseInt(tier.getAttribute('data-qty'), 10) || 1;
    c.slots[n] = c.slots[n] || [];
    c.slots[n].length = qty;
    var slotStyle = wrap.getAttribute('data-mp-style') === 'slots';

    var html = '';
    for(var i=0;i<qty;i++){
      var v = byId(c, c.slots[n][i]);
      if(slotStyle){
        html += '<button type="button" class="mp-slot-box'+(v?' filled':'')+'" data-i="'+i+'" '+
                'onclick="mpOpen(\''+sid+'\','+i+')" aria-label="'+(v ? v.title : 'Choose flavour '+(i+1))+'">'+
                (v ? ((v.img ? '<img src="'+v.img+'" alt="">' : '') + '<b>'+v.title+'</b>'+
                      '<span class="mp-slot-note">1/1 &#10003; · tap to change</span>')
                   : '<span class="plus">+</span>'+
                     '<span class="mp-slot-lbl">'+(qty>1 ? 'Bundle '+(i+1)+' flavor' : 'Choose your flavor')+'</span>'+
                     '<span class="mp-slot-note">0/1</span>') +
                '</button>';
      } else {
        html += '<button type="button" class="mp-cir'+(v?' filled':'')+'" data-i="'+i+'" '+
                'onclick="mpOpen(\''+sid+'\','+i+')" aria-label="'+(v ? v.title : 'Choose '+c.optionName)+'">'+
                '<span class="mp-cir-in">'+ (v
                    ? (v.img ? '<img src="'+v.img+'" alt="">' : '<b>'+v.title.charAt(0)+'</b>')
                    : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>') +
                '</span><em>'+ (v ? v.title : (qty>1 ? '#'+(i+1) : 'Pick')) +'</em></button>';
      }
    }
    box.innerHTML = html;
    wrap.hidden = false;
    var head = wrap.querySelector('[data-mp-vp-h]');
    head.textContent = slotStyle ? '' : c.optionName + (qty > 1 ? ' — pick ' + qty : '');
    head.hidden = slotStyle;
    box.style.gridTemplateColumns = 'repeat(' + Math.min(qty, 3) + ',minmax(0,1fr))';
    closePick(r);
  }

  function byId(c, id){
    if(!id) return null;
    for(var k=0;k<c.variants.length;k++) if(String(c.variants[k].id) === String(id)) return c.variants[k];
    return null;
  }
  function closePick(r){
    var p = r.querySelector('[data-mp-pick]');
    if(p){ p.hidden = true; p.innerHTML = ''; }
    var m = r.querySelector('[data-mp-modal]');
    if(m) m.hidden = true;
    r.querySelectorAll('.mp-cir,.mp-slot-box').forEach(function(b){ b.classList.remove('open'); });
  }
  window.mpClosePick = function(sid){ var r = root(sid); if(r) closePick(r); };

  /* Tapping a circle reveals the flavour list right beneath the row, so the
     picker costs no vertical space until it is actually needed. */
  window.mpOpen = function(sid, i){
    var c = cfg(sid), r = root(sid); if(!c || !r) return;
    var pick = r.querySelector('[data-mp-pick]');
    var btn  = r.querySelector('.mp-cir[data-i="'+i+'"], .mp-slot-box[data-i="'+i+'"]');
    if(!pick || !btn) return;
    var modal = r.querySelector('[data-mp-modal]');
    if(btn.classList.contains('open')){ closePick(r); return; }
    closePick(r);
    btn.classList.add('open');
    var cur = c.slots[c.tier][i];
    pick.innerHTML = c.variants.map(function(v){
      return '<button type="button" class="mp-opt'+(String(cur)===String(v.id)?' on':'')+'"'+
        (v.available ? '' : ' disabled') +
        ' onclick="mpChoose(\''+sid+'\','+i+','+v.id+')">'+
        (v.img ? '<img src="'+v.img+'" alt="">' : '') +
        '<span>'+v.title+'</span>'+(v.available?'':'<small>Sold out</small>')+'</button>';
    }).join('');
    pick.hidden = false;
    if(modal){
      var qtyNow = (c.slots[c.tier]||[]).length || 1;
      var t = modal.querySelector('[data-mp-modal-title]');
      var sb = modal.querySelector('[data-mp-modal-sub]');
      if(t) t.textContent = qtyNow > 1 ? 'Select the flavor for Bundle ' + (i+1) : 'Choose your flavor';
      if(sb) sb.innerHTML = 'Pick <b>1 of ' + c.variants.length + '</b> (' + (cur ? '1' : '0') + '/1)';
      modal.hidden = false;
    }
  };

  window.mpChoose = function(sid, i, vid){
    var c = cfg(sid), r = root(sid); if(!c || !r) return;
    c.slots[c.tier][i] = vid;
    renderSlots(sid);
    /* Advance to the next empty circle so picking 3 flavours is three taps. */
    var next = -1;
    for(var k=0;k<c.slots[c.tier].length;k++) if(!c.slots[c.tier][k]){ next = k; break; }
    if(next > -1) mpOpen(sid, next);
  };

  window.mpTier = function(sid, n){
    var c = cfg(sid), r = root(sid); if(!c || !r) return;
    c.tier = n;
    r.querySelectorAll('[data-mp-tier]').forEach(function(t){
      var on = parseInt(t.getAttribute('data-mp-tier'),10) === n;
      t.classList.toggle('on', on);
      t.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    renderSlots(sid);
    mpTotal(sid);
  };

  /* ---------- total ---------- */
  window.mpTotal = function(sid){
    var c = cfg(sid), r = root(sid); if(!c || !r) return;
    var tier = r.querySelector('[data-mp-tier="'+c.tier+'"]'); if(!tier) return;
    var cents = parseInt(tier.getAttribute('data-cents'),10) || 0;
    var bump = r.querySelector('#mpBump-'+sid);
    if(bump && bump.checked) cents += parseInt(bump.getAttribute('data-cents'),10) || 0;
    var out = r.querySelector('[data-mp-total]');
    /* innerHTML, not textContent: moneySample comes from {{ 100000 | money }},
       and the shop's money format wraps amounts in <span class=cvc-money> for
       the currency app — textContent would print that markup to the customer. */
    if(out) out.innerHTML = money(cents, c.moneySample);
  };

  /* Message for the Buy-on-WhatsApp button. Built from the same cfg the
     add-to-cart uses, so what lands in the inbox can never drift from what the
     customer actually configured: tier quantity, chosen flavours, live total.
     Reads the price from [data-mp-total] with textContent, not innerHTML, so the
     currency app's <span class=cvc-money> wrapper never reaches the message. */
  window.mpWaText = function(sid){
    var c = cfg(sid), r = root(sid);
    if(!c || !r) return '';
    var parts = [];
    if(c.title) parts.push(c.title);

    var tier = r.querySelector('[data-mp-tier="'+c.tier+'"]');
    var qty = tier ? (parseInt(tier.getAttribute('data-qty'),10) || 1) : 1;
    if(qty > 1) parts.push(qty + ' packs');

    if(c.hasVariants){
      var chosen = (c.slots[c.tier] || []).map(function(id){
        var v = byId(c, id); return v ? v.title : null;
      }).filter(Boolean);
      if(chosen.length) parts.push(chosen.join(', '));
    }

    var out = r.querySelector('[data-mp-total]');
    var price = out ? (out.textContent || '').trim() : '';
    if(price) parts.push(price);

    return 'Hi Energyze, I would like to order: ' + parts.join(' — ');
  };

  /* ---------- add to cart ---------- */
  function post(items, btn, label){
    btn.disabled = true;
    var original = label;
    btn.textContent = 'Adding…';
    return fetch('/cart/add.js', {
      method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({items: items})
    }).then(function(res){
      btn.disabled = false;
      if(res.ok){
        btn.innerHTML = original;
        try { if(window.ezbCartAdded) ezbCartAdded(); else window.location.href='/cart'; }
        catch(e){ window.location.href='/cart'; }
        return;
      }
      return res.json().catch(function(){ return {}; }).then(function(b){
        var msg = (b && (b.description || b.message)) || '';
        var txt = res.status === 422
          ? (/can add|already|only have|items? in your cart/i.test(msg) ? 'Max in cart' : 'Sold out')
          : 'Try again';
        btn.textContent = txt;
        setTimeout(function(){ btn.innerHTML = original; }, 2600);
      });
    }).catch(function(){
      btn.disabled = false;
      btn.textContent = 'Try again';
      setTimeout(function(){ btn.innerHTML = original; }, 2600);
    });
  }

  window.mpAdd = function(sid, btn){
    var c = cfg(sid), r = root(sid); if(!c || !r) return;
    var tier = r.querySelector('[data-mp-tier="'+c.tier+'"]'); if(!tier) return;
    var qty = parseInt(tier.getAttribute('data-qty'),10) || 1;
    var agg = {};
    if(c.hasVariants){
      var chosen = (c.slots[c.tier]||[]).slice(0, qty);
      var missing = -1;
      for(var k=0;k<qty;k++) if(!chosen[k]){ missing = k; break; }
      if(missing > -1){
        /* Don't silently add a flavour the customer never picked. */
        r.querySelectorAll('.mp-cir').forEach(function(b){
          if(!b.classList.contains('filled')){
            b.classList.add('err');
            setTimeout(function(){ b.classList.remove('err'); }, 1200);
          }
        });
        mpOpen(sid, missing);
        r.querySelector('[data-mp-vp]').scrollIntoView({block:'center', behavior:'smooth'});
        return;
      }
      chosen.forEach(function(id){ agg[id] = (agg[id]||0)+1; });
    } else {
      agg[c.defaultVariant] = qty;
    }
    var items = Object.keys(agg).map(function(id){ return {id: parseInt(id,10), quantity: agg[id]}; });
    var bump = r.querySelector('#mpBump-'+sid);
    if(bump && bump.checked && bump.getAttribute('data-vid')) items.push({id: parseInt(bump.getAttribute('data-vid'),10), quantity:1});
    post(items, btn, btn.innerHTML);
  };

  /* Jump to the reviews section, clearing the sticky header. Falls back to the
     browser's own anchor handling if the target isn't on this page. */
  window.mpJump = function(a){
    var id = (a.getAttribute('href') || '').replace(/^.*#/, '');
    if(!id) return true;
    var el = document.getElementById(id) ||
             document.querySelector('.reviews, [data-reviews], #shopify-block-reviews');
    if(!el) return true;
    var head = document.querySelector('.site-header, .header, header');
    var off  = head ? head.getBoundingClientRect().height + 16 : 24;
    var top   = el.getBoundingClientRect().top + window.pageYOffset - off;
    var start = window.pageYOffset;
    try { window.scrollTo({ top: top, behavior: 'smooth' }); }
    catch(e){ window.scrollTo(0, top); }
    /* Smooth scrolling is a no-op in some contexts; make sure the jump still lands. */
    setTimeout(function(){
      if(Math.abs(window.pageYOffset - start) < 4) window.scrollTo(0, top);
    }, 260);
    return false;
  };

  /* Accordion rows. Animating an explicit measured height, then releasing to auto,
     so a row still opens correctly if its content reflows (images, tables, fonts). */
  function accSet(row, open, animate){
    var body = row.querySelector('.mp-acc-b');
    var btn  = row.querySelector('.mp-acc-h');
    row.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    clearTimeout(row._t);
    if(!animate){ body.style.height = open ? 'auto' : '0px'; return; }
    var target = body.scrollHeight;
    if(open){
      body.style.height = '0px';
      void body.offsetHeight;               /* commit the start height */
      body.style.height = target + 'px';
      row._t = setTimeout(function(){
        if(row.classList.contains('is-open')) body.style.height = 'auto';
      }, 300);
    } else {
      body.style.height = target + 'px';
      void body.offsetHeight;               /* pin the pixel height before collapsing */
      body.style.height = '0px';
    }
  }
  window.mpAcc = function(btn){
    var row = btn.closest('.mp-acc');
    accSet(row, !row.classList.contains('is-open'), true);
  };

  window.mpUp = function(vid, btn){
    btn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({items:[{id: vid, quantity:1}]})
    }).then(function(res){
      btn.classList.remove('is-loading');
      if(res.ok && window.ezbCartAdded) ezbCartAdded();
      else if(res.ok) window.location.href='/cart';
    }).catch(function(){ btn.classList.remove('is-loading'); });
  };

  function boot(){
    document.querySelectorAll('[data-mp]').forEach(function(r){
      var sid = r.getAttribute('data-mp');
      var c = cfg(sid); if(!c) return;
      renderSlots(sid);
      mpTotal(sid);
      r.querySelectorAll('.mp-acc').forEach(function(row){
        accSet(row, row.classList.contains('is-open'), false);
      });
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
